.dda-breadcrumb {
  display: inline-flex;
  align-items: center;
  list-style: none;
  padding: 0;
  margin: 0;
}

.breadcrumb-item {
  display: flex;
  align-items: center;
}

.dda-breadcrumb,
.breadcrumb-item{
  gap: 18px;
}

.breadcrumb-item a {
  display: flex;
  align-items: center;
  justify-content: center;
  text-decoration: none;
  font-size: var(--dda-fs-body-lg);
  gap: 4px;
}
.breadcrumb-item a span{
  color: var(--dda-on-surface-0);
  font-weight: var(--dda-fw-500);
}
.light-mode .breadcrumb-item a span{
  color: var(--dda-neutral-0);
}
/**/
.breadcrumb-item i,
.breadcrumb-item svg {
  font-size: 16px;
  color: var(--dda-on-surface-variant-30);
}
.light-mode .breadcrumb-item i,
.light-mode .breadcrumb-item svg {
  color: var(--dda-neutral-variant-30);
}
/**/
.breadcrumb-item .separator {
  margin: 0 8px;
  color: var(--dda-on-surface-variant-30);
}
.light-mode .breadcrumb-item .separator {
  color: var(--dda-neutral-variant-30);
}
/**/
.breadcrumb-item.active a span{
  color: var(--dda-on-surface-variant-30);
  font-weight: var(--dda-fw-400);
}
.light-mode .breadcrumb-item.active a span{
  color: var(--dda-neutral-variant-30);
}
